import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getHeaderZones } from 'Utils/Redfast';

export const RedfastZone = ({ name = '' }) => (name ? <div data-rf-zone={name} /> : null);

export const RedfastZoneByPathname = () => {
  const { pathname = '' } = useLocation();
  const routes = useSelector((s) => s.appConfig.routes);
  const rfZoneName = useMemo(() => getHeaderZones(pathname, routes), [pathname, routes]);

  return <RedfastZone name={rfZoneName} />;
};
